import Vue from 'vue'
const openMenu = new Vue()
export default openMenu



// WEBPACK FOOTER //
// ./client/events/openMenu.js